// extracted by css-extract-rspack-plugin
export default {"resource":"Resource_resource__ECFk5","deselectButton":"Resource_deselectButton__bh6vN"};